export const convertToLeadTime = (requestBufferDuration = 0) => {
  const days = Math.floor(requestBufferDuration / 86400);
  const hours = Math.floor((requestBufferDuration % 86400) / 60 / 60);
  return {
    days: days,
    hours: hours,
  };
};

export const convertToRequestBufferDuration = (days?: string, hours?: string) => {
  return Number(days || 0) * 24 * 60 * 60 + Number(hours || 0) * 60 * 60;
};
